export const AUTH_UPDATEATTR = 'AUTH_UPDATEATTR';

export function updateAttr(payload) {
  return {
    type: AUTH_UPDATEATTR,
    payload,
  };
}
